import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { CmhEnergyProductionConfigurationState } from './types'

export const getters: GetterTree<CmhEnergyProductionConfigurationState, RootState> = {}
